import { AddProcedureStockAllowanceType } from '../entity';
import ProcedureCard from './ProcedureCard';

type ProcedureListProps = {
  procedures: Array<{
    id?: string;
    stepOrder: number;
    type: 'SALE' | 'CONSUMPTION';
    description?: string | null;
    stockAllowances: AddProcedureStockAllowanceType;
  }>;
  isVisitClosed: boolean;
  isPreviousCopy?: boolean;
};

const ProcedureList = ({
  procedures,
  isVisitClosed,
  isPreviousCopy = false,
}: ProcedureListProps) => (
  <>
    {procedures.map(procedure => (
      <ProcedureCard
        key={procedure.id}
        disabled={isVisitClosed}
        isPreviousCopy={isPreviousCopy}
        procedureId={procedure.id}
        orderNumber={procedure.stepOrder}
        type={procedure.type}
        description={procedure.description ?? ''}
        stockAllowances={procedure.stockAllowances}
      />
    ))}
  </>
);
export default ProcedureList;
